import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/inputs/button"
import memo from "set-state-compare/build/memo"
import {NewsletterTemplate} from "models"
import NewsletterTemplatesTable from "components/newsletter-templates/table"
import Routes from "shared/routes"
import {useAdminLayout} from "components/admin/layout"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {View} from "react-native"

/** @typedef {object} RoutesAdminNewsletterTemplatesIndexProps */

/** @typedef {object} RoutesAdminNewsletterTemplatesIndexState */

/**
 * @extends {ShapeComponent<RoutesAdminNewsletterTemplatesIndexProps, RoutesAdminNewsletterTemplatesIndexState>}
 */
class RoutesAdminNewsletterTemplatesIndex extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.newsletter_templates.index"})
    const adminLayout = useAdminLayout()
    const canCan = useCanCan(() => [[NewsletterTemplate, ["create"]]])

    this.canCan = canCan
    this.t = t

    useMemo(() => {
      adminLayout?.setState({actions: this.actions(), active: "newsletter-templates", headerTitle: NewsletterTemplate.modelName().human({count: 2})})
    }, [adminLayout, canCan.getCacheKey()])
  }

  render() {
    return (
      <View dataSet={{route: "admin-newsletter-templates--index"}}>
        <NewsletterTemplatesTable adminLayout />
      </View>
    )
  }

  actions = () => <>
    {this.tt.canCan.can("create", NewsletterTemplate) &&
      <Button
        className="new-newsletter-template-button"
        icon="plus"
        label={this.tt.t(".add_new_newsletter_template")}
        to={Routes.newAdminNewsletterTemplatePath()}
      />
    }
  </>
}

export default memo(shapeComponent(RoutesAdminNewsletterTemplatesIndex))
